if settings.include_images
    each decl in declarations
        if decl.type == 'bitmap'
            | static const uint8_t !{decl.data.name}[] = {!{decl.data.value}};
            |
            |
if settings.declare_vars
    each decl in declarations
        if decl.type == 'var'
            if decl.data.type === 0
                | const char* !{decl.data.name} = "!{decl.data.value}";
            else
                | int !{decl.data.name} = !{decl.data.value};
            |
            |
each layer in layers
    if layer.type == 'polygon'
        - var pts = layer.points
        |
        | void !{layer.functionName}(Canvas* canvas) {
        |
        - for (var pi = 0; pi < pts.length; pi++)
            - var npi = (pi + 1) % pts.length
            |     canvas_draw_line(canvas, !{pts[pi][0]}, !{pts[pi][1]}, !{pts[npi][0]}, !{pts[npi][1]});
            |
        | }
        |
|
|
- var pad = settings.wrap ? '    ' : ''
if settings.wrap
    | void draw!{screenTitle}(Canvas* canvas) {
    | !{pad}canvas_set_bitmap_mode(canvas, true);
    |
    |
- var font = ''
- var drawColorMode = 1;
each layer in layers 
    if settings.comments
        | !{pad}// !{layer.name}
        |
    if layer.inverted 
        if drawColorMode != 2
            | !{pad}canvas_set_color(canvas, 2);
            |
            - drawColorMode = 2;
    else
        if drawColorMode != 1
            | !{pad}canvas_set_color(canvas, 1);
            |
            - drawColorMode = 1;
    case layer.type
        when 'line'
            | @!{layer.uid};!{pad}canvas_draw_line(canvas, !{layer.x1}, !{layer.y1}, !{layer.x2}, !{layer.y2});
        when 'rect'
            - var func = `canvas_draw_${layer.radius? 'r': ''}${layer.fill ? 'box' : 'frame'}`;
            | @!{layer.uid};!{pad}!{func}(canvas, !{layer.x}, !{layer.y}, !{layer.w}, !{layer.h}!{layer.radius? `, ${layer.radius}`: ''});
        when 'circle'
            - var func = layer.fill ? 'canvas_draw_disc' : 'canvas_draw_circle'
            | @!{layer.uid};!{pad}!{func}(canvas, !{layer.x}, !{layer.y}, !{layer.radius});
        when 'triangle'
            - var minX = Math.min(layer.x1, layer.x2, layer.x3)
            - var maxX = Math.max(layer.x1, layer.x2, layer.x3)
            - var minY = Math.min(layer.y1, layer.y2, layer.y3)
            - var maxY = Math.max(layer.y1, layer.y2, layer.y3)
            - var base = maxX - minX
            - var height = maxY - minY
            - var orientation = 'CanvasDirectionBottomToTop'
            | @!{layer.uid};!{pad}canvas_draw_triangle(canvas, !{minX}, !{minY}, !{base}, !{height}, !{orientation});
        when 'string'
            if layer.font != font
                - font = layer.font
                | !{pad}canvas_set_font(canvas, !{layer.font});
                |
            if layer.isTextVariable
                | @!{layer.uid};!{pad}canvas_draw_str(canvas, !{layer.x}, !{layer.y}, !{layer.text});
            else
                | @!{layer.uid};!{pad}canvas_draw_str(canvas, !{layer.x}, !{layer.y}, "!{layer.text}");
        when 'paint'
        when 'icon'
            | @!{layer.uid};!{pad}canvas_draw_xbm(canvas, !{layer.x}, !{layer.y}, !{layer.w}, !{layer.h}, !{layer.imageName});
        when 'polygon'
            | @!{layer.uid};!{pad}!{layer.functionName}(canvas);
        default 
            |
            | // Unknown layer type !{layer.type}
            |
    |
    |
    |
if settings.wrap
    | }
